import React, { useState } from "react";
import { FaSpinner, FaTimes } from "react-icons/fa";
import { FiTrash2 } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  deleteMultipleUsers,
  fetchUsers,
} from "../../../redux/slices/userSlice";

export default function DeleteMultipleUsers({
  selectedUserIds = [],
  onClearSelection,
}) {
  const [showModal, setShowModal] = useState(false);
  const statusDeleteMultipleUser = useSelector(
    (state) => state.user?.statusDeleteMultipleUser
  );
  const dispatch = useDispatch();

  const handleCancel = () => {
    setShowModal(false);
    onClearSelection?.(); // ✅ Clear selection on cancel
  };

  console.log(selectedUserIds);

  const handleDelete = async () => {
    try {
      if (selectedUserIds.length === 0) {
        toast.warn("No users selected for deletion");
        return;
      }

      // ✅ Send payload in the required format
      const payload = { user_ids: selectedUserIds };

      const res = await dispatch(deleteMultipleUsers(payload)).unwrap();

      dispatch(fetchUsers());
      onClearSelection?.();

      toast.success(res.message);
      setShowModal(false);
    } catch (error) {
      toast.error(error?.message);
      console.error(error);
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setShowModal(true)}
        disabled={selectedUserIds.length === 0}
        className={`flex items-center gap-2 px-3 py-2 rounded-md transition-all duration-200
    ${
      selectedUserIds.length === 0
        ? "bg-gray-100 text-gray-400 cursor-not-allowed"
        : "bg-red-50 text-red-600 hover:bg-red-100 hover:shadow-lg"
    }`}
        title={
          selectedUserIds.length === 0
            ? "Select users to delete"
            : "Delete selected users"
        }
      >
        <FiTrash2 className="text-lg" />
        <span>Delete Selected</span>
        {selectedUserIds.length > 0 && (
          <span className="ml-1 text-sm font-medium text-gray-500">
            ({selectedUserIds.length})
          </span>
        )}
      </button>

      {showModal && (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-full max-w-md mx-auto my-6">
              <div className="border-0 rounded-lg p-6 shadow-lg bg-white relative flex flex-col outline-none focus:outline-none">
                <button
                  onClick={() => setShowModal(false)}
                  className="absolute top-3 right-3 text-gray-400 hover:text-gray-900"
                >
                  <FaTimes className="text-xl" />
                  <span className="sr-only">Close modal</span>
                </button>
                <h1 className="text-2xl text-center text-gray-800 font-semibold mb-4">
                  Confirm Deletion
                </h1>
                <p className="text-center text-gray-600 mb-6">
                  Are you sure you want to delete{" "}
                  <strong>{selectedUserIds.length}</strong>{" "}
                  {selectedUserIds.length > 1 ? "users" : "user"}? This action
                  cannot be undone.
                </p>
                <div className="flex justify-center gap-4">
                  <button
                    onClick={handleCancel}
                    className="px-4 py-2 text-sm font-semibold bg-gray-100 text-gray-700 rounded-lg"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleDelete}
                    className="flex items-center gap-2 px-4 py-2 text-sm font-semibold bg-red-600 text-white rounded-lg"
                    disabled={statusDeleteMultipleUser === "loading"}
                  >
                    {statusDeleteMultipleUser === "loading" ? (
                      <>
                        <FaSpinner className="animate-spin" />
                        Deleting...
                      </>
                    ) : (
                      "Delete"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 bg-black opacity-25 z-40"></div>
        </>
      )}
    </>
  );
}
